import React, { useEffect, useRef, useState } from 'react';
import { isUuid } from '../../stores/util';
import * as S from './error-dialog.styles';
import { IErrorPayload } from './util';

interface IErrorDialogProps {
    payload: IErrorPayload;
    onClose: () => void;
}

export const ErrorDialog: React.FunctionComponent<IErrorDialogProps> = (
    props: IErrorDialogProps,
): React.ReactElement => {
    const { payload, onClose } = props;
    const [claimId, setClaimId] = useState<string>();
    const textRef = useRef<HTMLTextAreaElement>(null);

    const pretty = (d: object) => JSON.stringify(d, undefined, 2);
    const onChange = () => undefined;
    const selectAll = () => {
        if (textRef && textRef.current) {
            textRef.current.select();
        }
    };
    useEffect(() => {
        // derive claim ID from pathname, either '/claims/:cid' or '/:pid/claims/:cid'
        const paths = window.location.pathname.split('/').slice(1);
        const idx = paths.indexOf('claims');
        if (idx > -1) {
            const cid = paths[idx + 1];
            if (isUuid(cid)) {
                setClaimId(cid);
            }
        }
    }, []);
    const trace = {
        page_url: window.location.href,
        trace_id: payload.trace_id,
        code: payload.code,
        message: payload.message,
        errors: payload.errors,
        api_url: payload.url,
    };
    return (
        <S.DialogBody hideTrace={!!payload.hideTrace}>
            <S.Col>
                {payload.message}
                {!payload.hideTrace && (
                    <S.Textarea ref={textRef} rows={11} value={pretty(trace)} onChange={onChange} onClick={selectAll} />
                )}
            </S.Col>
            <S.Row onClick={onClose}>
                {!payload.demoBlocked && (
                    <S.Contact
                        action="report this error"
                        subject="Reporting a system error"
                        body={pretty(trace)}
                        claimId={claimId}
                    />
                )}
                <S.Spacer />
                <S.Button onClick={onClose}>OK</S.Button>
            </S.Row>
        </S.DialogBody>
    );
};
